<template>
  <li>
    <div class="card-elm-item" v-if="horaireTraite.length">
      <i class="icon icon-opened"><span class="sr-only">Horaires d'ouverture</span></i>
      <div class="form-group">
        <div class="office-hours office-hours-modal">
          <button :aria-controls="'collapse-horaires' + id" :aria-expanded="!!isShow" class="collapse-toggle btn-accordion"  @click.prevent="isShow = !isShow; $emit('open', $event, isShow)"
           type="button" >
            <span v-if="open" class="status status--label status--open">Ouvert</span>
            <span v-else class="status status--label status--close">Fermé</span>
            <span class="status status--after"> {{ nextTimeMsg }} <span class="time">{{
             printTime(nextTime)
              }}</span>
              </span>
          </button>
        </div>
        <slide-up-down :id="'collapse-horaires' + id" :active="isShow" :duration="500" :style="isShow ? 'display:block;' : 'display:none;'">
          <div class="schedule">
            <ul class="timetable">
              <li class="timetable-row" v-for="(dayHoraires, keyDayHoraires) in horaireTraite" :key="keyDayHoraires">
                <div class="day">{{ getDay(dayHoraires[0]) }}</div>
                <div class="hours">
                <div class="hour" v-for="(hour, keyHour) in dayHoraires" :key="keyHour">{{
                      getHoursM(hour)
                  }} - {{ getHoursS(hour) }}</div>
                </div>
              </li>
            </ul>
          </div>
        </slide-up-down >
      </div>
    </div>
  </li>
</template>

<script>

import SlideUpDownRgaa from '@/components/legacy/Shared/plugins/slide-up-down-rgaa.vue';
import { hashGenerator } from '@/helpers';

export default {
  name: 'HoraireComponent',
  components: {
    'slide-up-down': SlideUpDownRgaa,
  },
  props: {
    horaires: Array,
    tz: String,
  },
  data() {
    return {
      isShow: false,
      horaireTraite: [],
      open: false,
      nextTime: null,
      nextTimeMsg: '- Ouvre à',
      daysTable: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    };
  },
  computed: {
    getTz() {
      if (!this.tz) {
        // Default timezone
        return 'Europe/Paris';
      }

      return this.tz;
    },
  },
  methods: {
    getDay(value) {
      if (!value) return '';
      const day = value.split('|')[0];
      const daysTable = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
      return daysTable[day];
    },
    getHoursM(value) {
      if (!value) return '';
      const startHour = value.split('|')[1];
      const hh = startHour.substr(0, startHour.length - 2);
      const mm = startHour.substr(-2);
      return `${hh}h${mm}`;
    },
    getHoursS(value) {
      if (!value) return '';
      const startHour = value.split('|')[2];
      const hh = startHour.substr(0, startHour.length - 2);
      const mm = startHour.substr(-2);
      return `${hh}h${mm}`;
    },
    printTime() {
      if (!this.nextTime) return '';
      const hh = this.nextTime.substr(0, this.nextTime.length - 2);
      const mm = this.nextTime.substr(-2);
      return `${hh}h${mm}`;
    },
    getTypeHours(value) {
      if (!value) return '';
      return value.split('|')[4];
    },
  },
  mounted() {
    const daysInWeek = 7;
    const daysTable = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    const daysTableISO = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const frenchOrder = [1, 2, 3, 4, 5, 6, 0, 1, 2, 3, 4, 5, 6, 0]; // two arr trick :)
    let startingDayIndex = 0;

    // eslint-disable-next-line no-underscore-dangle
    this.id = hashGenerator();

    const nowDate = new Date();
    const timezone = this.getTz;

    const nowDay = nowDate.toLocaleString('fr-FR', {
      weekday: 'long',
      timeZone: timezone,
    });

    const nowHour = parseInt(nowDate.toLocaleString('fr-FR', {
      hour: '2-digit',
      hour12: false,
      timeZone: timezone,
    }), 10);

    const nowMinute = parseInt(nowDate.toLocaleString('fr-FR', {
      minute: '2-digit',
      hour12: false,
      timeZone: timezone,
    }), 10);

    const nowTime = nowHour.toString() + ((nowMinute < 10 ? '0' : '') + nowMinute.toString());
    const nowTimeInt = parseInt(nowTime, 10);

    /** Sort days beginning with the present day */
    startingDayIndex = frenchOrder.indexOf(daysTableISO.indexOf(nowDay));

    if (this.horaires && this.horaires.length) {
      const horaireTable = [];
      const horaireTableOrdered = [];
      this.horaires.forEach((horaire) => {
        const h = horaire.split('|');

        if (h.length === 5) {
          if (h[4] === '1') {
            if (!horaireTable[parseInt(h[0], 10)]) {
              horaireTable[parseInt(h[0], 10)] = [];
            }

            horaireTable[parseInt(h[0], 10)].push(h);
          }
        }
      });

      if (horaireTable.length) {
        for (let dayIndex = startingDayIndex; dayIndex < daysInWeek + startingDayIndex; dayIndex += 1) {
          const currentDayIndex = frenchOrder[dayIndex];
          const hT = horaireTable[currentDayIndex];

          if (hT) {
            const pushedIndex = horaireTableOrdered.push([]) - 1;

            hT.forEach((t) => {
              const accumalator = t.map((elem, index) => {
                if (index > 0 && index < 3 && elem.length < 3) {
                  return ((elem.length < 2) ? '00' : '0') + elem;
                }
                return elem;
              }).join('|');
              horaireTableOrdered[pushedIndex].push(accumalator);
            });

            // Sorting horaire
            horaireTableOrdered[pushedIndex].sort((a, b) => {
              const a1 = parseInt(a.split('|')[1], 10);
              const b1 = parseInt(b.split('|')[1], 10);

              return a1 - b1;
            });
          }
        }

        const presentDay = daysTableISO.indexOf(nowDay);

        const currentDayCompareFunc = (byDay) => {
          byDay.forEach((_t) => {
            if (!this.open || this.nextTime === null) {
              const $t = _t.split('|');

              if ($t.length === 5) {
                const a = parseInt($t[1], 10);
                const b = parseInt($t[2], 10);

                if (a <= nowTimeInt && b >= nowTimeInt) {
                  this.open = true;
                  this.nextTime = $t[2];
                  this.nextTimeMsg = '- Ferme à';
                } else if (this.nextTime === null) {
                  if (a > nowTimeInt) {
                    this.nextTime = $t[1];
                  }
                }
              }
            }
          });
        };

        const nextDayCompareFunc = (byDay) => {
          byDay.forEach((_t) => {
            if (this.nextTime === null) {
              const $t = _t.split('|');

              if ($t.length === 5) {
                this.nextTime = $t[1];
                this.nextTimeMsg = `- Ouvre ${daysTable[parseInt($t[0], 10)]} à`;
              }
            }
          });
        };

        // check if open
        horaireTableOrdered.forEach((byDay) => {
          if (!this.open || this.nextTime === null) {
            const currentDayIndex = parseInt(byDay[0].split('|')[0], 10);

            if (presentDay === currentDayIndex) {
              currentDayCompareFunc(byDay);
            } else {
              // next day available
              nextDayCompareFunc(byDay);
            }
          }
        });

        if (this.nextTime === null) {
          if (horaireTableOrdered && horaireTableOrdered.length) {
            nextDayCompareFunc(horaireTableOrdered[0]);
          }
        }
        this.horaireTraite = horaireTableOrdered;
      }
    }
  },
};
</script>
<style lang='scss'>
.card-elm-item {
   button {
    border: none;
    background: none;
    padding: 0;
  }
  .status {
    margin-right: 3px;
    &--open{
      color: #21882b;
      font-weight: 600;
    }
    &--close {
      color: #b63337;
      font-weight: 600;
    }
  }
  .timetable {
    display: table;
    width: 100%;
    table-layout: auto;
    padding: 10px 0 !important;
    &-row {
      display: table-row;
      padding-bottom: 5px;
      .day {
        font-weight: 600;
        width: auto;
        white-space: nowrap;
        padding-right: 1.2em;
        min-width: 6.5em;
      }
      .hours{
        display: table-cell;
        width: 100%;
        padding-bottom: 8px;
      }
    }
  }
  .vuejs-collapse-link {
    i {
      margin: 10px;
    }
  }
}
</style>
